import FJActionConstant from '../constant/FJActionConstant';
import FJNetworkStore from '../store/FJNetworkStore';
import FJCaptcha from '../store/FJCaptcha';
import FJLocalStore from '../store/FJLocalStore';
import FJMessageStore from '../store/FJMessageStore';
import FJUtil from '../util/FJUtil';

const _getUseUrl = (countryCode) => {
  const googleUrl = 'https://www.google.com/recaptcha/api.js?render=explicit';
  const txUrl = 'https://turing.captcha.qcloud.com/TCaptcha.js';
  if (countryCode === 'CN') {
    return txUrl;
  } else {
    return googleUrl;
  }
}

export default {
  // 打开登录注册面板
  openLoginView: function (obj) {
    return {
      type: FJActionConstant.SHOW_LOGIN_VIEW,
      method: obj?.method ?? 'popup',
      page: obj.page,
      email: obj?.email ? obj.email : ''
    }
  },
  // 关闭登录注册面板
  closeLoginView: function () {
    return (dispatch, getState) => {
      let step = getState().mainStore.step
      dispatch({type: FJActionConstant.CLOSE_LOGIN_VIEW})
      if (step === 'resetPassword') {
        dispatch(this.changeStep('default'))
      }
    }
  },

  // 改变倒计时剩余时间
  setIntervalTime: (value) => {
    return {
      type: FJActionConstant.SET_INTERVAL_TIME,
      value,
    }
  },

  // 改变倒计时剩余时间
  changeVerificationTimeShow: (value) => {
    return {
      type: FJActionConstant.VERIFICATION_TIME_SHOW,
      value,
    }
  },

  // 改变忘记密码倒计时剩余时间
  setForgetPasswordIntervalTime: (value) => {
    return {
      type: FJActionConstant.SET_FORGET_PASSWORD_INTERVAL_TIME,
      value,
    }
  },

  // 改变忘记密码倒计时剩余时间
  changeForgetPasswordTimeShow: (value) => {
    return {
      type: FJActionConstant.FORGET_PASSWORD_TIME_SHOW,
      value,
    }
  },

  // 改变倒计时剩余时间
  changeRegisterCode: (registerCode) => {
    return {
      type: FJActionConstant.CHANGE_REGISTER_CODE,
      registerCode,
    }
  },

  // 改变步骤
  changeStep: (step) => {
    return {
      type: FJActionConstant.CHANGE_STEP,
      step: step
    }
  },

  // 注册密码改变
  changeRegisterPasswordAction: (password) => {
    return {
      type: FJActionConstant.CHANGE_REGISTER_PASSWORD,
      password: password
    }
  },

  // 邮箱改变
  changeEmail: (email) => {
    return {
      type: FJActionConstant.CHANGE_EMAIL,
      email: email
    }
  },
  // 改变 发送验证的邮箱
  changeConfirmEmail: (email) => {
    return {
      type: FJActionConstant.CHANGE_CONFIRM_EMAIL,
      confirmEmail: email
    }
  },

  forgetPasswordAction: function (obj) {
    return async (dispatch, getState) => {
      dispatch(this.changeConfirmEmail(obj.email))
      dispatch(this.changeStep('confirmationEmail'))
    }
  },

  // 检查邮件账号是否存在
  checkEmail: function (obj, callback) {
    return (dispatch, getState) => {
      FJNetworkStore.checkAccountExist(obj).then((result) => {
        // 状态码，200注册 201登录 215参数错误 500发送验证码失败
        let code = result.code
        callback({result: true})
        if (code === 200) {
          dispatch(this.changeStep('verifyEmailCode'))
          dispatch(this.changeConfirmEmail(obj.email))
        } else if (code === 201) {
          dispatch(this.changeStep('login'))
        } else if (code === 215) {
          callback({result: false, errTip: FJLocalStore._('enter-valid-email')})
        } else if (code === 500) {
          callback({result: false, errTip: FJLocalStore._('failed-send-code')})
        }
        // callback({result: true})
      }).catch(() => {
        callback({networkFail: true, errTip: FJLocalStore._('network-error')})
      })
    }
  },

  changeCountryCode: function (countryCode) {
    return {
      type: FJActionConstant.CHANGE_COUNTRY_CODE,
      countryCode: countryCode
    }
  },

  loadCaptchaApi: function (callback) {
    return async (dispatch, getState) => {
      const countryCode = getState().mainStore.countryCode;
      const url = _getUseUrl(countryCode);
      try {
        await FJCaptcha.loadApi(url);
        callback && callback()
      } catch (e) {
        throw new Error(e)
      }
    }
  },

  // 邮箱注册
  emailRegister: function (data, callback) {
    return async (dispatch, getState) => {

      let method = getState().mainStore.method
      let page = getState().mainStore.page;
      const email = getState().mainStore.email;
      let origin = method === 'single' ? page : window.location.pathname;

      const __doStatistics = (reason) => {
        FJUtil.ealog('sign up error', {
          'error reason': reason,
          'error mode': 'email',
          'error page': "page_" + origin,
          'error account': email
        });
      }

      let _register = (data) => {
        FJNetworkStore.emailRegister({...data}).then((res) => {
          if (res.code === 200) {
            FJUtil.ealog('sign up', {
              "signUpMode": 'email',
              'page&panel': method === 'single' ? 'page' : 'panel',
              'signUpPage': "page_" + origin,
              'signUpAccount': "Account_" + data.email
            });
            dispatch(this.changeRegisterPasswordAction('')) // 注冊成功删除密码
            dispatch(this.emailLogin({email: data.email, password: data.password}, () => {
            }, false))
          } else if (res.code === 305) {
            callback({result: false, errTip: FJLocalStore._('enter-valid-email')});
            __doStatistics(res.code);
          } else if (res.code === 316) {
            // 验证码错误
            dispatch(this.changeStep('default'))
            FJMessageStore.addMessage(FJLocalStore._('invalid-verification-code'), 'error');
            __doStatistics(res.code);
          } else if (res.code === 317) {
            // 验证码过期
            dispatch(this.changeStep('default'))
            FJMessageStore.addMessage(FJLocalStore._('flow-overtime'), 'error');
            __doStatistics(res.code);
          } else if (res.code === 404) {
            window.location.href = '/404.html';
            __doStatistics(res.code);
          } else if (res.code === 500) {
            __doStatistics(res.code);
            window.location.href = '/' + res.data.link;
          } else {
            __doStatistics('sign up failed');
            FJMessageStore.addMessage(FJLocalStore._('sign-up-failed'), 'error');
            // callback({result: false, errTip: FJLocalStore._('sign-up-failed')})
          }
        }).catch((e) => {
          __doStatistics('reg network error');
          if (callback) {
            callback({networkFail: true, errTip: FJLocalStore._('network-error')})
          }
        })
      }

      _register(data);
      return;

      let timeout15 = null;

      FJCaptcha.beginRecaptcha((option) => {
        _register({
          email: data.email,
          password: data.password,
          ...option
        })
        try {
          clearTimeout(timeout15);
          timeout15 = null;
        } catch (e) {
          console.log(e)
        }
      }, (type) => {
        if (type === 'networkFail' || type === 'TX networkFail' || type === 'No Grecaptcha') {
          if (callback) {
            callback({networkFail: true, errTip: FJLocalStore._('network-error')})
          }
          __doStatistics(type);
        } else if (type === 'clean') {
          // dispatch(this.changeRegisterPasswordAction(''))
          // if (callback) {
          //     callback({type: 'clean'})
          // }
        } else if (type === 'cancel' || type === 'TX cancel' || type === 'cancel expired') {
          if (callback) {
            callback({result: false})
          }
          __doStatistics(type);
        }
        // else {
        //     if (callback) {
        //         callback({result: true})
        //     }
        // }
        try {
          clearTimeout(timeout15);
          timeout15 = null;
        } catch (e) {
          console.log(e)
        }
      }, 'register')


      try {
        timeout15 = setTimeout(() => {
          clearTimeout(timeout15);
          timeout15 = null;

          _register({
            email: data.email,
            password: data.password,
            sr: 1
          })
        }, 15 * 1000);
      } catch (e) {
        console.log(e)
      }


    }
  },
  // 邮箱登录
  emailLogin: function (data, callback, isLoginByLoginButton = true) {
    return async (dispatch, getState) => {
      let method = getState().mainStore.method
      const __recaptchaLogin = async (loginSource) => {
        const __funDone = () => {

          let timeout15 = null;

          FJCaptcha.beginRecaptcha((option) => {
            _login({
              email: data.email,
              password: data.password,
              ...option
            }, {
              captcha_source: loginSource === 305 ? 1 : 0,
              captcha: 1
            });

            try {
              clearTimeout(timeout15);
              timeout15 = null;
            } catch (e) {
              console.log(e)
            }

          }, (errorMsg) => {
            if (callback) {
              callback({
                result: true,
              })
            }

            try {
              clearTimeout(timeout15);
              timeout15 = null;
            } catch (e) {
              console.log(e)
            }


          }, 'login');

          try {
            timeout15 = setTimeout(() => {
              clearTimeout(timeout15);
              timeout15 = null;

              _login({
                email: data.email,
                password: data.password,
                sr: 1
              }, {
                captcha_source: loginSource === 305 ? 1 : 0,
                captcha: 1
              });

            }, 15 * 1000);
          } catch (e) {
            console.log(e)
          }

        }
        // 正在加载sdk
        if (FJCaptcha.getApiIsApiLoading()) {
          await FJUtil.polling(() => FJCaptcha.getApiIsApiLoading() === false);
          __funDone();
        } else {
          if (!FJCaptcha.getApiIsLoaded()) {
            try {
              await dispatch(this.loadCaptchaApi());
              __funDone();
            } catch (e) {
              if (callback) {
                callback({
                  result: true,
                })
              }
            }
          } else {
            __funDone();
          }
        }
      }

      let _login = (option, recordOptions = {}) => {
        FJNetworkStore.emailLogin({...option}).then((res) => {
          if (res.code === 200) {
            window.needLoginRecaptcha = false;
            if (method !== 'single') {
              dispatch(this.changeStep('default'))
              dispatch(this.closeLoginView())
              window.fjuser.dispatchCallbacks(window.fjuser.eventType.login, true, res);
              // dispatch(this.changeEmail(''))
            } else {
              window.location.href = FJUtil.getBaseUrl()
            }
          } else if (res.code === 205) {
            if (callback) {
              callback({
                result: false,
                errTip: FJLocalStore._("password-err")
              })
            }
            if (res.data.needCaptcha) {
              window.needLoginRecaptcha = res.data.needCaptcha
            }
          } else if (res.code === 305) {
            if (res.data.needCaptcha) {
              __recaptchaLogin(305);
            }
          } else if (res.code === 404) {
            window.location.href = '/404.html';
          } else if (res.code === 500) {
            window.location.href = '/' + res.data.link;
          }
        }).catch((err) => {
          if (callback) {
            callback({networkFail: true, errTip: FJLocalStore._('network-error')})
          }
        });


      }
      if (window.needLoginRecaptcha === true) {
        __recaptchaLogin(205);
      } else {
        _login({email: data.email, password: data.password}, {
          captcha: 0,
        })
      }
    }
  },
  // 发送验证码
  sendCode: function (obj, callback) {
    return async (dispatch, getState) => {
      let result = await FJNetworkStore.checkAccountExist({email: obj.email}).catch(() => {
        if (callback) {
          callback({result: false, errTip: FJLocalStore._('network-error')})
        }
      })
      if (result.code === 201) {
        // console.log(obj)
        FJNetworkStore.sendEmail(obj).then((result) => {
          let code = result.code
          if (code === 200) {
            if (callback) {
              callback({result: true})
            }
            dispatch(this.changeStep('verificationCode'))
            // dispatch(this.changeConfirmEmail(''))
          } else if (code === 216) {
            FJMessageStore.addMessage(FJLocalStore._('code-click-frequently'), 'warning');
            if (callback) {
              callback({result: true})
            }
            // if (callback) {
            //     callback({result: false, errTip: FJLocalStore._('code-click-frequently')})
            // }
          } else if (code === 500) {
            if (callback) {
              callback({result: false, errTip: FJLocalStore._('failed-send-code')})
            }
          } else {
            if (callback) {
              callback({result: false, errTip: FJLocalStore._('request-failed-try-again')})
            }
          }
          // if (callback) {
          //     callback()
          // }

        }).catch((err) => {
          if (callback) {
            callback({networkFail: true, errTip: FJLocalStore._('network-error')})
          }
        })
      } else if (result.code === 200) {
        if (callback) {
          callback({result: false, errTip: FJLocalStore._('email-is-not-registered')})
        }
      } else {
        if (callback) {
          callback({result: false, errTip: FJLocalStore._('request-failed-try-again')})
        }
      }
    }
  },

  // 重发验证码
  resendCode: function (obj, callback, errCallback) {
    return (dispatch, getState) => {
      FJNetworkStore.sendEmail(obj).then((result) => {
        let code = result.code
        if (callback) {
          callback(result)
        }
        if (code === 200) {
          FJMessageStore.addMessage(FJLocalStore._('success-send-code'), 'message');
        } else if (code === 216) {
          FJMessageStore.addMessage(FJLocalStore._('code-click-frequently'), 'warning');
        } else if (code === 500) {
          FJMessageStore.addMessage(FJLocalStore._('failed-send-code'), 'warning');
        } else {
          FJMessageStore.addMessage(FJLocalStore._('request-failed-try-again'), 'warning');
        }
      }).catch((err) => {
        FJMessageStore.addMessage(FJLocalStore._('network-error'), 'error');
        if (errCallback) {
          errCallback(err)
        }
      })
    }
  },


  /**
   * @description 验证输入的验证码是否正确
   * @param obj， {code, email, type}, type 类型 1:注册 2:忘记密码
   * @param callback
   * @returns {function(*, *): void}
   */
  confirmCode: function (obj, callback) {
    return (dispatch, getState) => {
      let email = getState().mainStore.confirmEmail

      FJNetworkStore.confirmCode({
        email,
        ...obj
      }).then((result) => {
        // 状态码，200请求成功 215参数失败 316验证码错误 317验证码过期
        let code = result.code
        if (code === 200) {
          dispatch(this.changeStep(`${obj.type === 1 ? 'setPassword' : 'resetPassword'}`))
          dispatch(this.changeRegisterCode(obj.code))
          callback({result: true})
        } else if (code === 316) {
          callback({result: false, errTip: FJLocalStore._('invalid-verification-code')})
        } else if (code === 317) {
          callback({result: false, errTip: FJLocalStore._('expired-code')})
        } else {
          callback({result: false, errTip: FJLocalStore._('request-failed-try-again')})
        }
      }).catch(() => {
        callback({networkFail: true, errTip: FJLocalStore._('network-error')})
      })
    }
  },
  // 重置密码
  resetPassword: function (data, callback) {
    return (dispatch, getState) => {
      let email = getState().mainStore.confirmEmail
      FJNetworkStore.resetPassword({
        email: email,
        newPassword: data.newPassword,
        confirmPassword: data.confirmPassword,
        code: data.code
      }).then((result) => {
        let code = result.code
        // 状态码，200：请求成功 215参数错误 316验证码错误 317 验证码过期 500网络错误
        // 305 密码长度不对 205 两次密码不匹配 201 新旧密码一样 这个状态前端已经做了判断进行规避
        if (code === 200) {
          dispatch(this.emailLogin({email: email, password: data.confirmPassword}))
        } else if (code === 317) {
          // 验证码过期提示
          dispatch(this.changeStep('default'))
          dispatch(this.changeRegisterCode(''))
          FJMessageStore.addMessage(FJLocalStore._('reset-flow-overtime'), 'error');
        } else if (code === 500) {
          callback({result: false, errTip: FJLocalStore._('request-failed-try-again')})
        } else if (code === 514) {
          callback({result: false, errTip: FJLocalStore._('enter-valid-email')})
        } else {
          callback({result: false, errTip: FJLocalStore._('request-failed-try-again')})
        }
      }).catch(() => {
        callback({networkFail: true, errTip: FJLocalStore._('network-error')})
      })
    }
  },
  sendGoogleTokenAction: function (accessToken) {
    return (dispatch, getState) => {
      let method = getState().mainStore.method
      let page = getState().mainStore.page
      let origin = method === 'single' ? page : window.location.pathname
      FJNetworkStore.sendGoogleToken(accessToken).then((res) => {
        if (res.data.register === true) {
          FJUtil.ealog('sign up', {
            "signUpMode": 'google',
            'page&panel': method === 'single' ? 'page' : 'panel',
            'signUpPage': "page_" + origin,
            'signUpAccount': "Account_" + res.data.email
          });
        }
        if (method !== 'single') {
          dispatch(this.closeLoginView())
          window.fjuser.dispatchCallbacks(window.fjuser.eventType.login, true, res);
        } else {
          // window.location.href = FJLocalStore.getJumpUrl('/editor/')
          window.location.href = FJUtil.getBaseUrl()
        }

        if (res.code !== 200) {
          FJUtil.ealog('sign up error', {
            'error reason': res.message,
            'error mode': 'Google',
            'error page': "page_" + origin,
            'error account': 'Google'
          });
        }

      }).catch(e => {
        FJUtil.ealog('sign up error', {
          'error reason': 'connectGoogleUser catch',
          'error mode': 'Google',
          'error page': "page_" + origin,
          'error account': 'Google'
        });
      })
    }
  },
  sendFacebookTokenAction: function (accessToken) {
    return (dispatch, getState) => {
      let method = getState().mainStore.method
      let page = getState().mainStore.page
      let origin = method === 'single' ? page : window.location.pathname
      FJNetworkStore.sendFacebookToken(accessToken).then((res) => {
        if (res.data.register === true) {
          FJUtil.ealog('sign up', {
            "signUpMode": 'facebook',
            'page&panel': method === 'single' ? 'page' : 'panel',
            'signUpPage': "page_" + origin,
            'signUpAccount': "Account_" + res.data.email
          });
        }
        if (method !== 'single') {
          dispatch(this.closeLoginView())
          window.fjuser.dispatchCallbacks(window.fjuser.eventType.login, true, res);
        } else {
          // window.location.href = FJLocalStore.getJumpUrl('/editor/')
          window.location.href = FJUtil.getBaseUrl()
        }

        if (res.code === 303) {
          FJUtil.ealog('sign up error', {
            'error reason': 'facebook without email',
            'error mode': 'Facebook',
            'error page': "page_" + origin,
            'error account': 'Facebook'
          });
          return
        }

        if (res.code !== 200) {
          FJUtil.ealog('sign up error', {
            'error reason': res.message || res.msg,
            'error mode': 'Facebook',
            'error page': "page_" + origin,
            'error account': 'Facebook'
          });
        }

      }).catch(e => {
        FJUtil.ealog('sign up error', {
          'error reason': 'connectFacebookUser catch',
          'error mode': 'Facebook',
          'error page': "page_" + origin,
          'error account': 'Facebook'
        });
      })
    }
  },
  changeLoginPasswordStatusAction: function (status) {
    return {
      type: FJActionConstant.CHANGE_LOGIN_PASSWORD_STATUS,
      status: status
    }
  },

  forceUpdate: function () {
    return {
      type: FJActionConstant.FORCE_UPDATE,
    }
  },
}
